import { useAuth } from 'react-oidc-context';
import { UnauthorisedResponse } from '~/lib/api/unauthorised-response';
import { ApiResponse } from '../api-response';
import { authedFetch } from '../authed-fetch';
import { parseResult } from '../parse-result';
import { AddPrePayResponse } from './types';
import { getApiPath } from './get-api-path';
import { usePaymentPath } from './use-payment-path';
import { useCallback } from 'react';
import { useTenant } from '@parcel2go/npm-p2g-app';

export interface IApiResponse<T> {
  success: boolean;
  result: T | null;
}

export function usePaymentApi() {
  const { user } = useAuth();
  const paymentPath = usePaymentPath('prepay');
  const { tenant } = useTenant();

  const generatePrePayLink = useCallback(
    async (amount: number, currency: string = 'GBP'): Promise<ApiResponse<AddPrePayResponse>> => {
      if (!user?.access_token) {
        return UnauthorisedResponse;
      }
      const url = getApiPath(`prepay/create`);
      const response = await authedFetch(
        tenant,
        url,
        { method: 'POST', body: JSON.stringify({ Amount: amount, CurrencyCode: currency }) },
        user?.access_token
      );
      return parseResult<AddPrePayResponse>(response).then((x) => {
        if (x.success) {
          x.result.link = `${paymentPath}?id=${x.result.orderId}&hash=${encodeURIComponent(x.result.hash)}`;
        }
        return x;
      });
    },
    [user, paymentPath, tenant]
  );

  return {
    generatePrePayLink
  } as const;
}
